module.exports = __webpack_public_path__ + "static/ipad-fba8d11880b3c5091094b5dddc3e228c.png";